import { useCallback } from 'react';
import { getPresignedS3UrlMultipartUpload } from '../config';
import useRequestCallback from './useRequestCallback';

export function usePreSignedUrlMultipartUploadCallback() {
  const { callback, loading, requestInstance } = useRequestCallback(
    useCallback(async (request, {
      fileKey,
      headers,
      fileFolder,
      parts = 1,
      uploadId: fileId,
      company,
      tags
    }) => {
      const response = await request.exec(getPresignedS3UrlMultipartUpload(
        {
          uploadId: fileId,
          fileKey,
          fileFolder,
          headers,
          parts,
          company,
          tags
        }
      ));
      return response;
    }, [])
  );
  return {
    callback,
    loading,
    requestInstance
  };
}

export default usePreSignedUrlMultipartUploadCallback;
